import React from 'react';
import './HomeConnectRoom.scss';
import CTAButton from '../../UI/CTA/CTAButton/CTAButton';

/**
 * Renders Connect Room section on the homepage
 * @param {String} heading
 * @param {String} desc
 * @param {String} ctaText
 * @param {String} ctaLink
 * @param {String} backgroundImg
 * @param {boolean} disable
 * @returns {JSX.Element}
 * @constructor
 */
const HomeConnectRoom = ({ heading, desc, ctaText, ctaLink, backgroundImg, disabled }) =>
  !disabled && (
    <div className="c-connect-room" style={{ backgroundImage: `url(${backgroundImg})` }}>
      <div className="c-connect-room__content">
        <h3 className="c-connect-room__heading h3-right-grotesk">{heading}</h3>
        <p className="c-connect-room__desc h3-roobert">{desc}</p>
        <CTAButton
          text={ctaText}
          link={ctaLink}
          target="_self"
          type="primary"
          additionalClasses="c-connect-room__cta cta"
        />
      </div>
    </div>
  );

export default HomeConnectRoom;
